import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table.component';
import { NgxBootstrapIconsModule, eye, pencil, download, arrowClockwise } from 'ngx-bootstrap-icons';
import { RouterModule } from '@angular/router';
import { CellComponent } from './cell/cell.component';
import { IsGuardedModule } from '../is-guarded/is-guarded.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedTranslateModule } from '../../shared/shared-translate.module';
import { getActiveLocale } from '../../shared/locale.util';

const icons = {
  eye,
  pencil,
  download,
  arrowClockwise,
};

@NgModule({
  declarations: [TableComponent, CellComponent],
  imports: [
    CommonModule,
    NgxBootstrapIconsModule.pick(icons),
    RouterModule,
    IsGuardedModule,
    NgbTooltipModule,
    SharedTranslateModule
  ],
  providers: [{ provide: LOCALE_ID, useFactory: getActiveLocale }],
  exports: [TableComponent],
})
export class TableModule {}
